import React from 'react';
import { Button } from '@xingternal/button';
import { Column, Row } from '@xingternal/xing-grid';
import styles from './styles.css';

export interface LanguageSelectorProps {
  handleSelectedLanguage: (language: string) => void;
  currentLocale: string;
  submitting: boolean;
}

const LOCALES = ['en', 'de', 'es', 'fr'];
// background-color: #DBE2E6;
export const LanguageSelector = ({
  currentLocale,
  handleSelectedLanguage,
  submitting,
}: LanguageSelectorProps): React.ReactElement => {
  const activeClass = (language: string): string => {
    return language === currentLocale ? styles.buttonActive : null;
  };
  return (
    <>
      <Row className={styles.localeButtonsContainer}>
        <Column className={styles.overrideButtons} size={12} offset={8}>
          {LOCALES.map(language => (
            <Button
              id={`language-${language}`}
              data-cy={`language-${language}`}
              disabled={submitting}
              className={activeClass(language)}
              key={language}
              type="button"
              onClick={(): void => {
                handleSelectedLanguage(language);
              }}
              size="small"
              variant="primary"
            >
              {language}
            </Button>
          ))}
        </Column>
      </Row>
    </>
  );
};
